import "./LeftNav.css";
import LeftNavButton from "./LeftNavButton";
import { ReactComponent as HexagonIcon } from "./static/icons/Hexagon.svg";
import { ReactComponent as SmileyFaceIcon } from "./static/icons/SmileyFace.svg";
import { ReactComponent as PillIcon } from "./static/icons/Pill.svg";
import { ReactComponent as PercentageIcon } from "./static/icons/Percentage.svg";

function LeftNav() {
  return (
    <div className="LeftNav">
      <LeftNavButton
        iconClassName="ExtraMargin"
        slideNumber={1}
        text="1 -  "
        icon={<HexagonIcon />}
        caseTitle="CASE 1"
      ></LeftNavButton>
      <LeftNavButton
        slideNumber={2}
        text="2 - "
        icon={<SmileyFaceIcon />}
        caseTitle="CASE 2"
      ></LeftNavButton>
      <LeftNavButton
        slideNumber={3}
        text="3 -"
        icon={<PillIcon />}
        caseTitle="CASE 3"
      ></LeftNavButton>
      <LeftNavButton
        slideNumber={4}
        text="4 - "
        icon={<PercentageIcon />}
        caseTitle="CASE 4"
      ></LeftNavButton>
    </div>
  );
}

export default LeftNav;
